import Api from './index';
import { FtueTour } from 'types';

const getTourSteps = (params?: any) => {
  return Api.get('/tours', { params });
};
const putTourStep = (tour: Array<FtueTour>) => {
  return Api.put('/users/me/tour', { data: tour });
};

export { getTourSteps, putTourStep };
